import { render, staticRenderFns } from "./AccettazioneSsnEditViewPageOld.vue?vue&type=template&id=19dc3d2d"
import script from "./AccettazioneSsnEditViewPageOld.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewPageOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports